angular.module('PatientApp').factory('TokenService', function($resource, $q, endpoints) {
    var Tokens = $resource(endpoints.tokens.primary.url, null, {
        retrieve: {
            method: 'GET'
        }
    });
    
    return {

        retrieve: function(token) {
            return Tokens.retrieve({
                token: token
            }).$promise.then(function(resp) {
                if (resp && resp.hasData()) {
                    return resp.getData();
                }
                return $q.reject(resp);
            });
        }

    };
});